import React, { Fragment, useMemo } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Center, Checkbox } from '@mantine/core';

import { NARROW_COLUMN_STYLES } from './constants';

export default function useColPocketCheckboxSchema({
    accessor, attributes, title, titleIcon, onChange,
}) {
    const WrapperTag = useMemo(() => (titleIcon ? Center : Fragment), [titleIcon]);

    const colPocketTitleSchema = {
        accessor,
        style: titleIcon ? NARROW_COLUMN_STYLES : {},
        title: titleIcon ? (
            <Center>
                <FontAwesomeIcon icon="lock" />
            </Center>
        ) : title,
        render: ({ row }) => (
            <WrapperTag>
                <Checkbox
                    {...(attributes || {})}
                    data-key={accessor}
                    name={row.id}
                    checked={row[accessor]}
                    onChange={onChange}
                />
            </WrapperTag>
        ),
    };

    return colPocketTitleSchema;
}
